module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (219).c57e5b53.jpg";